module.exports = __webpack_public_path__ + "static/media/result-1.4cf3561b.jpg";